import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/** Aperçu des termes (markdown) dans un bloc `.garantie-md` stylé par le module. */
export function TermsMarkdown({ body }: { body: string }) {
  if (!body.trim()) return <p className="garantie-md garantie-md--empty">Aucun terme rédigé.</p>;
  return (
    <div className="garantie-md">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{body}</ReactMarkdown>
    </div>
  );
}
